<template>
  <div>
    <div class="operate-btn">
      <router-link class="button is-success" :to="{name:'batchExportSizeImg'}">去生成图</router-link>
      <el-button size="mini" type="success" @click="add">新增</el-button>
      <a target="_blank" href="https://image3.ichuanyi.cn/Files/87/30/0e/87300e10cbb5db0b4d80387ee39e1ba92b201ad3_187717.png" download><el-button size="mini" type="primary">查看模板图</el-button></a>
    </div>
    <el-table :data="tableList" border width="800">
      <el-table-column prop="name" label="标题名称" align="center"></el-table-column>
      <el-table-column prop="goodsPic" label="商品信息标题图" align="center">
        <template slot-scope="scope">
          <popover :image="scope.row.goodsPic" :imgWidth="60"></popover>
        </template>
      </el-table-column>
      <el-table-column prop="sizePic" label="尺码标题图" align="center">
        <template slot-scope="scope">
          <popover :image="scope.row.sizePic" :imgWidth="60"></popover>
        </template>
      </el-table-column>
      <el-table-column prop="tryPic" label="试穿报告标题图" align="center">
        <template slot-scope="scope">
          <popover :image="scope.row.tryPic" :imgWidth="60"></popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="edit(scope.row)" v-if="scope.$index != 0">编辑</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row.id)" v-if="scope.$index != 0">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="编辑/新增特殊标题" :visible.sync="visible">
      <div>
        <el-form :model="form" ref="form">
          <el-form-item label="标题名称" prop="name">
            <el-input size="mini" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="商品信息" prop="goodsPic">
            <el-upload
              class="avatar-uploader"
              :action="server"
              :show-file-list="false"
              name="image"
              :on-success="handleGoodSuccess"
              :before-upload="beforeUpload">
              <div class="info">
                <el-button size="mini" type="primary">点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
                <span slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb，图宽限制750px</span>
              </div>
              <image-component :image="form.goodsPic" :width="200"></image-component>
            </el-upload>
          </el-form-item>
          <el-form-item label="尺码信息" prop="sizePic">
            <el-upload
              class="avatar-uploader"
              :action="server"
              :show-file-list="false"
              name="image"
              :on-success="handleSizeSuccess"
              :before-upload="beforeUpload">
              <div class="info">
                <el-button size="mini" type="primary">点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
                <span slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb，图宽限制750px</span>
              </div>
              <image-component :image="form.sizePic" :width="200"></image-component>
            </el-upload>
          </el-form-item>
          <el-form-item label="试穿信息" prop="tryPic">
            <el-upload
              class="avatar-uploader"
              :action="server"
              :show-file-list="false"
              name="image"
              :on-success="handleTrySuccess"
              :before-upload="beforeUpload">
              <div class="info">
                <el-button size="mini" type="primary">点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
                <span slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb，图宽限制750px</span>
              </div>
              <image-component :image="form.tryPic" :width="200"></image-component>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Popover from './popover'
export default {
  data() {
    return {
      tableList: [],
      visible: false,
      form: {
        name: '',
        goodsPic: '',
        sizePic: '',
        tryPic: ''
      }
    }
  },
  components: {
    Popover
  },
  computed: {
    server () {
      return process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage'
    }
  },
  methods: {
    handleTrySuccess(response) {
      this.form.tryPic = response.data.images.info.path
    },
    handleSizeSuccess(response) {
      this.form.sizePic = response.data.images.info.path
    },
    handleGoodSuccess (response, file) {
      this.form.goodsPic = response.data.images.info.path
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt2M = file.size / 1024 < 10000

      if (!isJPG) {
        this.$message('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt2M
    },
    del(id) {
      this.$confirm('是否确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(()=>{
          HttpRequest.get('/admin.php?method=goods.deleteSizePic', { id: id}).then(res => {
            this.getList()
            this.$message('删除成功')
          })
        }).catch(() => {
          this.$message('已取消删除')
        });
    },
    edit(row) {
      this.form = Object.assign(this.form, row)
      this.visible = true
    },
    add() {
      this.visible = true
      this.form = {
        name: '',
        goodsPic: '',
        sizePic: '',
        tryPic: ''
      }
    },
    save() {
      if (!this.form.name) {
        this.$message('请填写名称')
        return
      }
      if (!this.form.goodsPic || !this.form.sizePic || !this.form.tryPic) {
        this.$message('请上传图片')
        return
      }
      let params = Object.assign({}, this.form)
      HttpRequest.get('/admin.php?method=goods.updateSizePic', params).then(res => {
        if (res.data.errMsg) {
          this.$message(res.data.errMsg)
          return
        }
        this.visible = false
        this.getList()
      })
    },
    getList() {
      HttpRequest.get('/admin.php?method=goods.getSizePicList').then(res => {
        this.tableList = _.toArray(res.data.list)
      })
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
.el-table {
  width: 800px;
}
.operate-btn {
  margin-bottom: 10px;
  .button {
    font-size: 12px;
    height: 28px;
    margin-right: 5px;
  }
  .el-button {
    margin-right: 5px;
  }
}
.el-input {
  width: 200px;
}
.el-upload__tip {
  color: red;
}
</style>
